export const kPaymentsSignupPath = 'api/v1/payments/checkout'
export const kPaymentsPartnerPath = 'api/v1/payments/partner'
export const kPaymentsSurveyPathV2 = 'api/v1/payments/survey-v2'
export const kPaymentsPortalPath = 'api/v1/payments/portal'
export const kPaymentsSubscriptionPath = 'api/v1/payments/subscription'
export const kPaymentsPreAuthorizationPath = 'api/v1/payments/pre-authorization'
export const kPaymentsSetupIntentPath = 'api/v1/payments/setup_intent'
export const kChatHtmlToDocxPath = '/api/v1/sourceviewer/html_to_docx'

// Assistant (Agent)
export const kAgentAssistantRouterApiBasePath = '/api/v1/assistant' // Non-WebSocket
export const kAgentAssistantChatBasePath = '/api/v1/assistant/chat' // WebSocket

// Agent Assistant Source HTML paths
export const kSourceCaselawHtmlAgent = `${kAgentAssistantRouterApiBasePath}/caselaw/html`
export const kSourceLrrHtmlAgent = `${kAgentAssistantRouterApiBasePath}/lrr/html`

// Agent Assistant metadata paths
export const kSourceLrrMetadataAgent = `${kAgentAssistantRouterApiBasePath}/lrr/metadata`

// Artifact
export const kArtifactApiBasePath = '/api/v1/artifact'
export const kArtifactVersionsBasePath = kArtifactApiBasePath + '/versions'
export const kArtifactDownloadDocxApiPath = kArtifactVersionsBasePath + '/{artifactVersionId}/docx'
export const kArtifactViewableUrlApiPath = kArtifactVersionsBasePath + '/{artifactVersionId}/viewable-url'
export const kArtifactUpdateVersionPath = kArtifactVersionsBasePath + '/{artifactVersionId}'

// Source view paths
export const kSourceApiLrr = '/api/v1/lrr/reference'
export const kSourceApiLrrV3 = '/api/v1/lrr_v3/reference' // supports refs with data-versions <= 4

// Caselaw HTML
export const kSourceCaseLawHtmlV3 = '/api/v1/caselaw_v3/caselaw_html'
// Caselaw Metadata
export const kSourceCaseLawMetadataV3 = '/api/v1/caselaw_v3/case_metadata'

// Public hosted file paths
export const kCaseLawCourtsFilePath = '/filters/case_law_courts.min.json'
export const kLrrSourcesFilePath = '/filters/lrr_sources.min.json'

// Medical Chronology
export const kMedChronApiBasePath = '/api/v1/med_chron'

// Timeline (Single Matter)
export const kTimelineApiBasePath = '/api/v1/timeline'

// Medical Billing Summaries
export const kMedSummaryApiBasePath = '/api/v1/med_summary'

// Organizations
export const kGetUserOrgData = '/api/v1/organization'
export const kCreateOrganization = '/api/v1/organization/v2'

// Organizations - Admin
export const kOrgBasePath = '/api/v1/organization'
export const kOrgUserOAuthBrandOnboardPath = '/api/v1/organization/user/brand/onboard'

// Citator V2
export const kCitatorGetCaseStatusApiPathV2 = 'api/v1/citator_v2/case-status'
export const kCitatorGetCaseCitationsApiPathV2 = 'api/v1/citator_v2/case-citations'
export const kCitatorGetCitingCasesApiPathV2 = 'api/v1/citator_v2/citing-cases'
export const kCitatorGetRelatedCasesApiPathV2 = 'api/v1/citator_v2/related-cases'

// Payments
export const kPaymentsValidatePromoCodeApiPath = '/api/v1/payments/promotion'
export const kPaymentsCheckoutPricesApiPath = '/api/v1/payments/checkout-prices'
export const kPaymentsTrialDaysApiPath = '/api/v1/payments/trial-days'
export const kPaymentsDetailsPath = '/api/v1/payments/payment-details'

// Skills
export const kSkillsRouterBasePath = '/api/v1/assistant/skills'

// Response Feedback
export const kResponseFeedbackBasePath = '/api/v1/assistant/response-feedback'

// Referral
export const kReferralActivatePath = '/api/v1/referral/activate'
export const kReferralCodePath = '/api/v1/referral/code'

// Limit
export const kTokenLimitApiPath = '/api/v1/limit/tokens'

// User Settings
export const kSettingsBasePath = '/api/v1/settings'
export const kUserSettingsApiPath = '/api/v1/settings/user'

// User
export const kUserBootstrapPath = '/api/v1/user/bootstrap'

// Matters
export const kMatterBasePath = '/api/v1/matter/' // needs trailing slash
// Latest completed artifact version per artifact in a matter (the matter's drafts).
export const kMatterDraftsPath = kMatterBasePath + '{matterId}/artifact/versions/latest'

// User Files (new upload pipeline)
export const kUserFilesApiBasePath = '/api/v1/user-files'
export const kGoogleDriveAuthorizePath = `${kUserFilesApiBasePath}/google-drive/authorize`
export const kDropboxAuthorizePath = `${kUserFilesApiBasePath}/dropbox/authorize`
export const kBoxAuthorizePath = `${kUserFilesApiBasePath}/box/authorize`
export const kOneDriveAuthorizePath = `${kUserFilesApiBasePath}/onedrive/authorize`
export const kExternalStorageAccountsPath = `${kUserFilesApiBasePath}/external-storage/accounts`
export const kExternalStorageBasePath = `${kUserFilesApiBasePath}/external-storage`

// HFTA - High-Fidelity Template Adherence
export const kDocxTemplatingBasePath = '/api/v1/docx-templating'
export const kApplyTemplateApiPath = `${kDocxTemplatingBasePath}/apply-template`
export const kTemplateSelectionApiPath = (artifactId: string) => `${kDocxTemplatingBasePath}/artifacts/${artifactId}/template-selection`
